/**
 * Inline badge displaying a scan or report status with color coding.
 */

import { statusBgColor } from '@/utils/formatters';
import type { ScanStatus } from '@/types/scan';

interface StatusBadgeProps {
  status: ScanStatus;
  /** A completed scan in which some engines failed. */
  withErrors?: boolean;
}

export default function StatusBadge({ status, withErrors = false }: StatusBadgeProps) {
  const label = withErrors && status === 'completed' ? 'Completed with errors' : status.charAt(0).toUpperCase() + status.slice(1);
  const color = withErrors && status === 'completed' ? 'bg-amber-100 text-amber-800' : statusBgColor(status);
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ${color}`}
    >
      {label}
    </span>
  );
}
